import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';

import ES from "./languages/es.json"
import EN from "./languages/en.json"

const resources = {
    es: {
        translation: ES
    },
    en: {
        translation: EN
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;